import { reactLocalStorage } from "reactjs-localstorage";
// const BASE_URL = 'http://65.2.10.224:4049/api/admin/';
// const BASE_URL = 'https://admin.deshvidesh.ca/login'; newUrl
// const BASE_URL = 'https://api.deshvidesh.ca/api/admin/';
// const BASE_URL = 'http://159.89.170.210:4049/api/admin/';// http://159.65.153.109:5978

// const RAW_URL = "http://52.66.207.187:4049/api/"; // this is original

const RAW_URL = "https://api.deshvidesh.ca/api/"; // it is for live in company website

// const RAW_URL = "http://localhost:4049/api/";

const BASE_URL = `${RAW_URL}admin/`;

const ALLOW_ORIGIN = "52.66.207.187:4049";
const USER_TYPE = "Admin";

function get(endpoint, params) {
  return requestData(endpoint, params);
}

function post(endpoint, params) {
  return requestData(endpoint, params, "POST");
}

function put(endpoint, params) {
  return requestData(endpoint, params, "PUT");
}

function deletemethod(endpoint, params) {
  return requestData(endpoint, params, "DELETE");
}

async function requestData(url, data = {}, method = "GET") {
  let xhr = new XMLHttpRequest();
  xhr.open(method, BASE_URL + url);
  if (checkingAuth()) xhr.setRequestHeader("authorization", checkingAuth());
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader("Access-Control-Allow-Origin", ALLOW_ORIGIN);
  xhr.setRequestHeader("userType", USER_TYPE);

  return new Promise((resolve, reject) => {
    // console.log("string mal", JSON.stringify(data));
    if (method == "GET") {
      xhr.send();
    } else {
      xhr.send(JSON.stringify(data));
    }
    xhr.onload = () => {
      console.log(xhr.status);
      // console.log("jdjgfdgdfgdgfdgfdgdf", xhr);
      let response = JSON.parse(xhr.response);
      // console.log(response ,"sdgdgdfgdfgdf");

      if (
        xhr.status === 200 ||
        xhr.status === 400 ||
        xhr.status === 403 ||
        xhr.status === 500 ||
        xhr.status === 406
      ) {
        resolve(response);
      } else {
        reject(response);
      }
    };
  });
}

async function requestRawData(url, data = {}, method = "GET") {
  let xhr = new XMLHttpRequest();
  xhr.open(method, RAW_URL + url);
  if (checkingAuth()) xhr.setRequestHeader("authorization", checkingAuth());
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.setRequestHeader("Access-Control-Allow-Origin", ALLOW_ORIGIN);
  xhr.setRequestHeader("userType", USER_TYPE);

  return new Promise((resolve, reject) => {
    // console.log("string mal", JSON.stringify(data));
    if (method == "GET") {
      xhr.send();
    } else {
      xhr.send(JSON.stringify(data));
    }
    xhr.onload = () => {
      console.log(xhr.status);
      // console.log("jdjgfdgdfgdgfdgfdgdf", xhr);
      let response = JSON.parse(xhr.response);
      // console.log(response ,"sdgdgdfgdfgdf");

      if (
        xhr.status === 200 ||
        xhr.status === 400 ||
        xhr.status === 403 ||
        xhr.status === 500 ||
        xhr.status === 406
      ) {
        resolve(response);
      } else {
        reject(response);
      }
    };
  });
}

async function fileUplode(
  url,
  method,
  file,
  object_get = {},
  tokenCustom = null
) {
  let token = "";
  let user = reactLocalStorage.get("Auth");

  if (user && user != null && Object.keys(user).length > 0) {
    token = user;
  }
  // let bash_url = "http://13.127.101.102:5011/api/v1/";
  // let apiUrl = BASE_URL + url;

  let apiUrl = RAW_URL + url;

  if (token != "") {
    var toooo = token;
  }
  //  console.log("tokenn",toooo);
  let headers = {
    // 'Accept': 'application/json',
    // "Content-Type": "multipart/form-data",
    // "Access-Control-Allow-Origin": "http://13.127.101.102:5008",
    authorization: toooo,
    userType: "Admin",
    // 'Authorization': 'Bearer ' + login_status,
  };

  return await fetch(apiUrl, {
    method: method,
    body: file,
    redirect: "follow",
    headers: headers,
  })
    .then((response) => {
      console.log("responseee", response, headers);
      return response.json();
    })
    .then(
      (result) => {
        console.log("ResponIMG", result);
        return result;
      },
      (error) => {
        return error;
      }
    );
}

async function fileVideoUplode(
  url,
  method,
  file,
  object_get = {},
  tokenCustom = null
) {
  let token = "";
  let user = reactLocalStorage.get("Auth");
  // console.log("UserTok", user);
  if (user && user != null && Object.keys(user).length > 0) {
    token = user;
  }
  // let bash_url = "http://13.127.101.102:5011/api/v1/";
  let apiUrl = BASE_URL + url;
  // let data = new FormData();
  // data.append("image", file);
  // Object.keys(object_get).forEach(function (key) {
  //   let ddd = object_get[key];
  //   data.append(key, ddd);
  // });

  if (token != "") {
    var toooo = token;
  }
  //  console.log("tokenn",toooo);
  let headers = {
    // 'Accept': 'application/json',
    // "Content-Type": "multipart/form-data",
    // "Access-Control-Allow-Origin": "http://13.127.101.102:5008",
    authorization: toooo,
    userType: "Admin",
    // 'Authorization': 'Bearer ' + login_status,
  };

  return await fetch(apiUrl, {
    method: method,
    body: file,
    redirect: "follow",
    headers: headers,
  })
    .then((response) => {
      // console.log("responseee", response, headers);
      return response.json();
    })
    .then(
      (result) => {
        console.log("ResponIMG", result);
        return result;
      },
      (error) => {
        return error;
      }
    );
}

function checkingAuth() {
  let token = localStorage.getItem("Auth");
  // console.log("TOKEn", token);

  if (token) {
    return token;
  }
  return false;
}

export default {
  requestData,
  get,
  post,
  put,
  deletemethod,
  fileUplode,
  fileVideoUplode,
  requestRawData,
};
